export const REPO_FOLDER_PATH =
  "https://github.com/InterruptorPt/dados/tree/main/"
